import React, { Fragment, useContext } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import { TransitionGroup, CSSTransition } from 'react-transition-group'

import config from 'config'
import GlobalContext from 'core/contexts/global-context'
import Background from 'core/components/Background'
import Header from 'core/components/Header'
import Navigation from 'core/components/Navigation'
import Home from 'home/components/Home'
import About from 'about/components/About'
import Press from 'press/components/Press'
import Project from 'project/components/Project'
import ProjectIndex from 'project/components/ProjectIndex'
import Contact from 'contact/components/Contact'
import Conversations from 'conversation/components/Conversations'
import Dynamite from 'dynamite/components/Dynamite'
import ScreenSaver from 'core/components/ScreenSaver'
import LoadingVideo from 'core/components/LoadingVideo'

const Routes = props => {
  const globalContext = useContext(GlobalContext)

  return (
    <Router basename={config.basename}>
      <Route
        render={({ location }) => {
          return (
            <Fragment>
              {(!globalContext.mobile || location.pathname === '/') && <Background />}
              <Header />
              <TransitionGroup component={null}>
                <CSSTransition key={location.pathname} timeout={600} classNames="routes-anim">
                  <Switch location={location}>
                    <Route
                      exact
                      strict
                      path="/:url*"
                      render={props => <Redirect to={`${props.location.pathname}/`} />}
                    />

                    <Route path="/about" render={props => <About {...props} title="About" />} />

                    <Route
                      path="/contact"
                      render={props => <Contact {...props} title="Contact" />}
                    />

                    <Route
                      path="/press"
                      render={props => <Press {...props} title="Awards &amp; Media" />}
                    />

                    <Route
                      path="/projects"
                      render={props => {
                        return (
                          <ProjectIndex {...props} title="Projects" className="mod-fullscreen" />
                        )
                      }}
                    />

                    <Route
                      path="/project/:id"
                      render={props => <Project {...props} className="mod-fullscreen" />}
                    />

                    <Route
                      path="/conversations"
                      render={props => {
                        return <Conversations {...props} title="Conversations" />
                      }}
                    />

                    <Route path="/dynamite">
                      <Dynamite title="Dynamite" />
                    </Route>

                    <Route path="/">
                      <Home title="" className="mod-fade" />
                    </Route>
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
              <Navigation location={location} />
              {!globalContext.mobile && <ScreenSaver />}
              {!globalContext.mobile && <LoadingVideo />}
            </Fragment>
          )
        }}
      />
    </Router>
  )
}

export default Routes
